<mat-icon *ngIf="enabled"
    class="error-tooltip-trigger" 
    matTooltipClass="rto-tooltip"
    matTooltipPosition="above"  
    [matTooltip]="displayToolTipText"
    data-qa-id="rto-alert-message-icon">warning
</mat-icon>